<div class="landing-list-container d-flex flex-wrap">
  <h6 class="m-3 mb-0">{{ 'LANDING.NAVBAR_' + listType | translate }}</h6>
	<div class="list-col">
		<mat-card class="m-2">
			<div class="sticky-top">
				@if(showFilters) {
				<!-- <app-contract-notices-filters
					[role]="'landing'"
					[dataAdministrationType]="listType === 'contract-notices' ? 'CONTRACT_NOTICES' : 'CONTRACT_ANNOUNCEMENTS'"
					[resetFilters]="filtersStore"
					(actionRequested)="actionByTypeSplitter($event)" (click)="gotoLogin()"></app-contract-notices-filters> -->
				}
			</div>

			<div class="row pb-0 m-1">
				<div class="mat-elevation-z2 px-0">
					<table mat-table [dataSource]="dataSource">
						@for (column of displayedColumns; track $index) {
						<ng-container [matColumnDef]="column">
							<th mat-header-cell *matHeaderCellDef>
								@if(column === 'actions'){


								} @else {
								{{ 'LANDING.DATA_LIST_' + column.toUpperCase() | translate }}
								}
							</th>
							<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="gotoLogin()">
								@if (column !== 'country') {
								{{ parseItemData(element, column) }}
								} @else if(parseItemData(element, column)) {
								<img [src]="externalAssets + '/flags/' + parseItemData(element, column) + '.svg'" alt="" />
								}
							</td>
						</ng-container>
						}
						<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
					</table>

					<mat-paginator [pageSizeOptions]="pageOptions" [pageSize]="pageOptions[0]" (page)="itemAction('LIST_ITEMS')" showFirstLastButtons aria-label="Select page of users">
					</mat-paginator>
				</div>
			</div>
		</mat-card>
	</div>
</div>
